import axios from 'axios'

const API_URL = 'https://api.moben.eu/api/v1'
// const API_URL = 'http://192.168.1.137:80/api/v1'

const securedAxiosInstance = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
})

const plainAxiosInstance = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
})

securedAxiosInstance.interceptors.request.use(config => {
  const method = config.method.toUpperCase()
  if (method !== 'OPTIONS') {
  // if (method !== 'OPTIONS' && method !== 'GET') {
    config.headers = {
      ...config.headers,
      'Authorization': 'Bearer ' + localStorage.access
    }
  }
  return config
})

securedAxiosInstance.interceptors.response.use(null, error => {
  if (error.response && error.response.config && error.response.status === 401) {
    delete localStorage.access
    delete localStorage.email
    delete localStorage.signedIn
    location.replace('/')
  }

  return Promise.reject(error)
})

export { securedAxiosInstance, plainAxiosInstance }